import {Injectable} from '@angular/core';
import {formatDate} from '@angular/common';
import {AppConfig} from '../config/app.config';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Countries} from '../source/general_settings/Countries';
import {Router} from '@angular/router';
import {map} from 'rxjs/internal/operators';

@Injectable()
export class RequestsService {
  BE_ACCESS_CLIENT = 'APClient';
  BE_ACCESS_SECRET = 'APSecret';

  constructor(private http: HttpClient, private route: Router) {
  };

  getToken() {
    return window.localStorage.getItem(btoa('access_token'));
  }

  getAPIServer() {
    var protocol = AppConfig.NT_HTTP_PROTOCOL; // http
    var server = AppConfig.NT_API_ENDPOINT; // localhost
    return protocol + AppConfig.NT_HTTP_SEPARATOR + server;
  }

  clockTime(body: any) {
    const reqHeader = new HttpHeaders();
    reqHeader.append('Content-Type', 'application/json');
    let URI = this.getAPIServer() + 'user/user/timeclock';

    return this.http.post(URI, body, {headers: reqHeader});
  }

  getClockTime() {

    if (window.localStorage.getItem(btoa('clocktime'))) {
      let date1: string = atob(window.localStorage.getItem(btoa('clocktime')));
      let time_zone: string = atob(window.localStorage.getItem(btoa('time_zone')));

      let aestTime: any = new Date().toLocaleString('en-US', {timeZone: time_zone});
      aestTime = new Date(aestTime);
      // console.log('AEST time: '+aestTime.toLocaleString())

      let date2: string = formatDate(aestTime, 'yyyy-MM-dd HH:mm:ss', 'en');

      let diffInMs: number = Date.parse(date2) - Date.parse(date1);

      let msToHMS = this.msToHMS(diffInMs += 1000);
      return msToHMS;

    }
  }
  msToHMS(ms: number): string {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
    const minutes = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, '0');
    const seconds = (totalSeconds % 60).toString().padStart(2, '0');
  
    return `${hours}:${minutes}:${seconds}`;
  }

  transform(value: number): number {
    return Math.floor(value);
  }

  postRequestauthToken(url: any, _params: any) {
    let reqHeader = new HttpHeaders({'Authorization': 'Basic ' + btoa(AppConfig.NT_ACCESS_CLIENT + ':' + AppConfig.NT_ACCESS_SECRET)});
    reqHeader.append('Content-Type', 'application/json');
    let URI = this.getAPIServer() + url;

    return this.http.post(URI, _params, {headers: reqHeader});
  }

  getSettingsRequest(url: any) {
    const reqHeader = new HttpHeaders({'Authorization': 'Basic ' + btoa(AppConfig.NT_ACCESS_CLIENT + ':' + AppConfig.NT_ACCESS_SECRET)});
    reqHeader.append('Content-Type', 'application/json');

    let URI = this.getAPIServer() + url;

    return this.http.get(URI, {headers: reqHeader});
  }

  getprinterRequest(url: any) {

    const reqHeader = new HttpHeaders({'Authorization': 'Basic ' + btoa(AppConfig.NT_ACCESS_CLIENT + ':' + AppConfig.NT_ACCESS_SECRET)});
    reqHeader.append('Content-Type', 'application/json');

    let URI = this.getAPIServer() + url;   

    return this.http.get(URI,{headers: reqHeader});
  }


  getRequest(url: any, _params?: any) {

    let body = new HttpParams();
    return this.postRequest(url, body);

    //   const reqHeader = new HttpHeaders();
    //
    // reqHeader.append('Content-Type', 'application/json');
    //
    // let URI = this.getAPIServer() + url;
    //
    // return this.http.get(URI, { headers: reqHeader });
  }


  postRequest(url: any, body: any, contentType?: any) {
    let reqHeader = new HttpHeaders();
    if (contentType == 'multipart') {
      reqHeader.append('Content-Type', 'multipart/form-data');
    } else {
      reqHeader.append('Content-Type', 'application/json');
    }

    let URI = this.getAPIServer() + url;
    return this.http.post(URI, body, {headers: reqHeader});
  }


  getCounriesRequest(_params: any) {
    const reqHeader = new HttpHeaders();
    reqHeader.append('Content-Type', 'application/json');

    let URI = this.getAPIServer() + 'api/countries';
    return this.http.post(URI, _params, {headers: reqHeader});
  }

  getCurrenciesRequest() {
    const reqHeader = new HttpHeaders();
    reqHeader.append('Content-Type', 'application/json');

    let URI = this.getAPIServer() + 'api/currencies';
    let body = new HttpParams();
    return this.http.post(URI, body, {headers: reqHeader});
  }

  getTimeZone() {
    const reqHeader = new HttpHeaders();
    reqHeader.append('Content-Type', 'application/json');

    let URI = this.getAPIServer() + 'api/timezones';
    let body = new HttpParams();
    return this.http.post(URI, body, {headers: reqHeader});

  }

  getCities(params: any) {
    const reqHeader = new HttpHeaders();
    reqHeader.append('Content-Type', 'application/json');

    let URI = this.getAPIServer() + 'api/cities';
    return this.http.post(URI, params, {headers: reqHeader});
  }


  public CheckPermission(page_permission_id) {
    let permissions: any = [];
    permissions = JSON.parse(atob(window.localStorage.getItem(btoa('user_permission'))));
    if (permissions && permissions.length > 0) {
      permissions = JSON.parse(atob(window.localStorage.getItem(btoa('user_permission'))));
      if (permissions != '') {
        if (permissions.find(x => x.permission_id == page_permission_id)) {
          return true;
        } else {
          this.route.navigate(['/denied']);
        }
      }

    } else {
      this.route.navigate(['/404']);
    }
  }

  public CheckMenuPermission(page_permission_id) {
    let permissions: any = [];

    permissions = JSON.parse(atob(window.localStorage.getItem(btoa('user_permission'))));

    if (permissions && permissions.length > 0) {

      permissions = JSON.parse(atob(window.localStorage.getItem(btoa('user_permission'))));

      if (permissions.find(x => x.permission_id == page_permission_id)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  getSaasAPIServer() {
    var protocol = AppConfig.NT_HTTP_PROTOCOL; // http
    var server = AppConfig.NT_SAAS_BASEURL; // localhost
    return protocol + AppConfig.NT_HTTP_SEPARATOR + server;
  }

  getSaasBillingAPIServer() {
    var protocol = AppConfig.NT_HTTP_PROTOCOL; // http
    var server = AppConfig.NT_SAAS_BILLING_BASEURL; // localhost
    return protocol + AppConfig.NT_HTTP_SEPARATOR + server;
  }

  getSaasToken(body: any) {
    const reqHeader = new HttpHeaders({'Authorization': 'Basic QVBDbGllbnQ6QVBTZWNyZXQ='});
    reqHeader.append('Content-Type', 'application/json');
    let URI = this.getSaasAPIServer() + 'AdminPortal/oauth/token';
    return this.http.post(URI, body, {headers: reqHeader});
  }

  createMember(url: any, body: any, token: any) {
    const reqHeader = new HttpHeaders({'Authorization': 'Bearer ' + token});
    reqHeader.append('Content-Type', 'application/json');
    let URI = this.getSaasAPIServer() + url;
    return this.http.post(URI, body, {headers: reqHeader});
  }

  getUnAuthHeader(): HttpHeaders {
    // if (!this.unAuthHeader) {
    const headers = new HttpHeaders();
    let encoded = btoa(this.BE_ACCESS_CLIENT + ':' + this.BE_ACCESS_SECRET);
    headers.set('Authorization', 'Basic ' + encoded);
    headers.set('Content-Type', 'application/json');
    // }
    return headers;
  }

  // getSaasBillingToken(body: any) {
  //   const headers = this.getUnAuthHeader();
  //    const url = 'ProductLicensingApplication/auth/signIn?';
  //   let URI = this.getSaasBillingAPIServer() + url+body;
  //   // let URI = 'http://192.168.1.186:8090/ProductLicensingApplication/auth/signIn?username=admin&password=admin&grant_type=password';
  //   console.log(URI);
  //   return this.http.post(URI, body,{headers});
  // }
  getBillingAppStatus(url: any, body: any, token: any) {
    const reqHeader = new HttpHeaders({'X-AUTH-TOKEN': token});
    reqHeader.append('Content-Type', 'application/json');
    let URI = this.getSaasBillingAPIServer() + url;
    return this.http.post(URI, body, {headers: reqHeader});
  }

  getSaasBillingToken(body: any) {

    const url = 'ProductLicensingApplication/auth/signIn?';
    let headers = this.getUnAuthHeader();
    let getURL = this.getSaasBillingAPIServer() + url + 'username=' + body['email'] + '&password=' + body['password'] + '&grant_type=' + body['grantType'];
    console.log(getURL);
    return this.http.post(getURL, body, {headers})
      .pipe(map((response: Response) => {
        return response;
      }));

  }

  stcPayment(uri, body: any, head: any) {

    const url = AppConfig.NT_STC_PAY_URL;
    let getURL = url + uri;
    let reqHeader = new HttpHeaders({'Content-Type': 'application/json'});
    reqHeader = reqHeader.append('Access-Control-Allow-Origin', '*');
    reqHeader = reqHeader.append('X-ClientCode', head.payment_private_key);
    reqHeader = reqHeader.append('X-USERNAME', head.payment_username);
    reqHeader = reqHeader.append('X-PASSWORD', head.payment_password);

    return this.http.post(getURL, body, {headers: reqHeader});
  }

}
